module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "chapter-title-break",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTOCAnchor-26"
    }
  }), _vm._v("Table of Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "TOC-chapter-italic"
  }, [_c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB5#_idTOCAnchor-14"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter-italic"
  }, [_c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB6#_idTOCAnchor-13"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-chapter-italic"
  }, [_c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB7#_idTOCAnchor-12"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter-Title"
  }, [_c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB8#_idTOCAnchor-25"
    }
  }, [_vm._v("Chapter ")]), _vm._v("1\t"), _c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB8#_idTOCAnchor-11"
    }
  }, [_vm._v("The Bad Gene")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter-Title"
  }, [_c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB9#_idTOCAnchor-24"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB9#_idTOCAnchor-10"
    }
  }, [_vm._v("A Social Affair")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter-Title"
  }, [_c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB10#_idTOCAnchor-23"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB10#_idTOCAnchor-9"
    }
  }, [_vm._v("Breaking Point")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter-Title"
  }, [_c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB11#_idTOCAnchor-22"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB11#_idTOCAnchor-8"
    }
  }, [_vm._v("The Beginning of the End")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter-Title"
  }, [_c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB12#_idTOCAnchor-21"
    }
  }, [_vm._v("Chapter 5")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB12#_idTOCAnchor-7"
    }
  }, [_vm._v("A False Start")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter-Title"
  }, [_c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB13#_idTOCAnchor-20"
    }
  }, [_vm._v("Chapter 6")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB13#_idTOCAnchor-6"
    }
  }, [_vm._v("A Vicious Cycle")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter-Title"
  }, [_c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB14#_idTOCAnchor-19"
    }
  }, [_vm._v("Chapter 7")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB14#_idTOCAnchor-5"
    }
  }, [_vm._v("Van’s House")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter-Title"
  }, [_c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB15#_idTOCAnchor-18"
    }
  }, [_vm._v("Chapter 8")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB15#_idTOCAnchor-4"
    }
  }, [_vm._v("The Big Day")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter-Title"
  }, [_c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB16#_idTOCAnchor-17"
    }
  }, [_vm._v("Chapter 9")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB16#_idTOCAnchor-3"
    }
  }, [_vm._v("Little Blessings")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter-Title"
  }, [_c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB17#_idTOCAnchor-16"
    }
  }, [_vm._v("Chapter 10")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB17#_idTOCAnchor-2"
    }
  }, [_vm._v("God’s Promises Fulfilled")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter-Title"
  }, [_c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB18#_idTOCAnchor-15"
    }
  }, [_vm._v("Chapter 11")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/9781630472863_EPUB18#_idTOCAnchor-1"
    }
  }, [_vm._v("A New Perspective")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-554b7a33","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781630472863_EPUB-4.vue
// module id = 72
// module chunks = 0